import React from "react";
import { motion } from "framer-motion";
import "./why-choose-us.css";
import LazyBackground from "../../Lazy/lazy-background";

const WhyChooseUs = () => {
  const cardData = [
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg1.svg`,
      title: "Trusted & Secure",
      description:
        "We prioritize your privacy with state-of-the-art encryption and rigorous data protection protocols, ensuring that your genetic information is safeguarded at every stage.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg1.svg`,
      title: "Comprehensive and Accessible Testing",
      description:
        "Our broad selection of genetic tests covers critical areas – from hereditary cancer testing and prenatal screenings to help you evaluate your risk, to cancer testing for solid and myeloid cancers to aid with therapy selection. Tailored specifically for Africa's genetic diversity, we deliver precise, relevant, and all-encompassing insights.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg2.svg`,
      title: "User-Friendly Convenience",
      description:
        "Experience a seamless journey from start to finish. With intuitive online ordering, flexible sample collection (whether at home or in a lab), and rapid turnaround times, our service integrates effortlessly into your lifestyle.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg3.svg`,
      title: "Expert Support and Guidance",
      description:
        "Our dedicated team of genetic and medical professionals is here for you. We help interpret your results, answer your questions, and guide you with actionable recommendations to support your health decisions.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg3.svg`,
      title: "Affordability and Transparency",
      description:
        "We offer competitive pricing with no hidden fees—eliminating unnecessary intermediaries to make premium genetic testing both affordable and accessible.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg2.svg`,
      title: "Innovative Technology",
      description:
        "Leveraging the latest advancements in genomic science, our tests provide the most accurate and up-to-date genetic insights, empowering you with reliable data for informed healthcare planning.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg2.svg`,
      title: "Actionable, Personalized Health Integration",
      description:
        "Our detailed reports are infused with actionable insights, making it easy to incorporate your genetic information into a comprehensive health strategy, whether for preventative care or personalized treatment options.",
    },
    {
      svg: `${process.env.PUBLIC_URL}/assets/card-svg3.svg`,
      title: "Community Empowerment and Research",
      description:
        "Your participation not only benefits you, but it also fuels a broader initiative to advance healthcare research across Africa, playing a pivotal role in improving the health outcomes of entire communities.",
    },
  ];

  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };

  return (
    <motion.section
      id="why-choose-us"
      className="why-choose-us-section"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {/* <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/background.svg`}
        alt=""
        className="home-background home-background9"
        loading="lazy"
      /> */}
      {/* <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/background2.svg`}
        alt=""
        className="home-background home-background10"
        loading="lazy"
      /> */}
      <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/star1.png`}
        alt=""
        className="home-background home-star1"
        loading="lazy"
      />
      <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/star1.png`}
        alt=""
        className="home-background home-star2"
        loading="lazy"
      />
      <div className="why-choose-us-container">
        <div className="why-choose-us-title-container">
        <h2  className="why-choose-us-title">
          Why Choose Direct by Syndicate Bio?
        </h2>
        </div>
        <div className="why-choose-us-grid">
          {cardData.map((card, index) => (
            <motion.div
              key={index}
              className="why-choose-us-card"
              variants={itemVariants}
            >
              <div className="why-choose-us-card-svg-container">
                <img src={card.svg} alt="" className="why-choose-us-card-svg" />
              </div>
              <h3 className="why-choose-us-card-title">{card.title}</h3>
              <p className="why-choose-us-card-description">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default WhyChooseUs;